const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/middleware/oauth2.ts';
import { Store } from 'redux';
import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { logout } from 'App/actions/fixme.login';
import { getPatAppSettings } from 'App/utils/generalUtils';
import messages from './translations';
import { isSecuredLocationPath } from 'App/utils/urlLocationCheck';
import { getCorrectEndpoint } from './getCorrectEndpoint';
import { getPatapiToken } from 'App/store/login';
import { addSnackbar } from 'App/actions/snackbar';
import { IPatapiRequest } from './patapi';

const Log = Logger('middleware/oauth2');

/**
 * NOTE: We rewrite all calls to KISAPI as proper PATAPI (except for application/pdf) calls here.
 *
 * TODO: The PATAPI token needs to be renewed when it expires.
 * Should we use a refresh token? Should the PATAPI token never expire at all?
 */

export default function oauth2() {
    return (store: Store) => (next: any) => async (action: IPatapiRequest) => {
        const cfg = getPatAppSettings();

        let endp = action.endpoint.slice(cfg.apiHost.length);

        if (Array.isArray(cfg.apiHost)) {
            Log.error('Misconfiguration of apiHost! Multiple hosts not supported!');
        } else if (action.endpoint.startsWith(cfg.apiHost as string)) {
            // Rewrite KISAPI call to PATAPI call.
            if (endp[0] === '/') {
                endp = endp.slice(1);
            }
            const params: any = {};
            const qat = endp.indexOf('?');

            if (qat >= 0) {
                const it = new URLSearchParams(endp.slice(qat + 1)).entries();
                endp = endp.slice(0, qat);

                for (const [key, value] of it) {
                    params[key] = value;
                }
            }

            const body = {
                method: action.requestConfig.method,
                endp,
                params,
                callKisimSynedraServer: action.callKisimSynedraServer,
                body: action.requestConfig.body,
            };

            action.requestConfig.method = 'POST';
            action.requestConfig.body = JSON.stringify(body);

            action.endpoint = getCorrectEndpoint(store.getState());

            Log.info(`Rewrote KISAPI call to ${action.endpoint} with:`, body);
        } else if (!action.endpoint.startsWith('patapi') && !action.endpoint.startsWith('/api')) {
            Log.warn(`The endpoint was neither recognized as a patapi nor as a kisapi endpoint: ${action.endpoint}`);
        }

        // Add token to headers.

        const token = getPatapiToken();
        if (!action.isNoAuth) {
            if (!token && !isSecuredLocationPath()) {
                Log.error('Failed to call endpoint, missing token!', action);

                store.dispatch((logout as any)());

                const httpHeaders = new Headers();
                if (!action.isExternalApi) {
                    httpHeaders.append('content-type', 'application/json');
                }
                const body = { err: 'missing-token' };
                return new Response(JSON.stringify(body), {
                    headers: httpHeaders,
                    status: 401,
                    statusText: 'Unauthorized',
                });
            }
        }
        const response = await next(action);
        if (response.status === 401 && !action.isNoAuth) {
            Log.info('The token is no longer valid! Logout to allow User to relogin');
            store.dispatch(addSnackbar('warning', messages['401'], 10, false));
            store.dispatch((logout as any)());
        }
        return response;
    };
}
